import { render } from "./ParametersTab.vue?vue&type=template&id=5291eb4a&scoped=true"
import script from "./ParametersTab.vue?vue&type=script&lang=js"
export * from "./ParametersTab.vue?vue&type=script&lang=js"

import "./ParametersTab.vue?vue&type=style&index=0&id=5291eb4a&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5291eb4a"]])

export default __exports__